<!--
 * @Description: ^_^
 * @Author: sharebravery
 * @Date: 2022-05-12 17:12:14
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-06-20 16:45:18
-->

<script lang="ts" setup>
import { ref, useAttrs, watchEffect } from 'vue';
import { DatePicker } from 'ant-design-vue';
import type { DatePickerProps } from 'ant-design-vue';
import type { PanelMode } from 'ant-design-vue/lib/vc-picker/interface';
import type { Dayjs } from 'dayjs';
import dayjs from 'dayjs';

import type { IDatePickerProps } from '../types';
import { dateTime } from '../../hooks/useFilter';
import useForm, { readOnlySlot } from '../../form/src/useFormConfig';

interface IProps extends IDatePickerProps {
  picker?: PanelMode;
}

const props = withDefaults(defineProps<IProps>(), {
  picker: 'date',
});

const emit = defineEmits<{
  (event: 'update:value', value: Date | null): void;
  (event: 'change', value: Date | null): void;
}>();

const attrs = useAttrs();

const mValue = ref<Dayjs & (string | Dayjs)>();

function change(date: string | Dayjs, dateString: string) {
  let format = attrs.format as string;
  if ('show-time' in attrs || 'showTime' in attrs) format = 'YYYY-MM-DD HH:mm:ss';

  const value = date === null ? null : new Date(dayjs(date, props.picker).format(format));
  emit('update:value', value);
  emit('change', value);
}

const { getBindValue } = useForm<IDatePickerProps & DatePickerProps>({
  props,
  componentName: 'DatePicker',
  attrs: useAttrs(),
});

watchEffect(() => {
  if (getBindValue.value?.value) {
    mValue.value = dayjs(getBindValue.value?.value);
  } else {
    mValue.value = undefined;
  }
});
</script>

<script lang="ts">
export default {
  name: 'DatePicker',
  inheritAttrs: false,
};
</script>

<template>
  <span
    v-if="getBindValue?.readOnly || readOnlySlot in $slots"
    :class="getBindValue?.readOnlyClassName"
    :style="getBindValue.readOnlyStyle"
    ><slot :name="readOnlySlot" :text="getBindValue.value"
      ><span v-if="getBindValue.value">{{
        dateTime(getBindValue.value.toString(), getBindValue.format as string)
      }}</span>
    </slot>
  </span>
  <DatePicker v-else v-bind="getBindValue as any" v-model:value="mValue" @change="change" />
</template>
